var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 24,
    fill: "#F7EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#settings_svg__a)",
    d: "M77.575 33.071h-7.346a31 31 0 0 0-3.219-8.094l5.765-5.765a2.425 2.425 0 0 0 0-3.43L65.22 8.226a2.425 2.425 0 0 0-3.43 0l-5.608 5.609a31 31 0 0 0-8.152-3.493V2.425A2.425 2.425 0 0 0 45.604 0H34.918a2.425 2.425 0 0 0-2.425 2.425v7.772a31 31 0 0 0-8.42 3.46L19.077 8.66a2.425 2.425 0 0 0-3.43 0l-7.555 7.556a2.425 2.425 0 0 0 0 3.43l5.03 5.03a31 31 0 0 0-3.4 8.395H2.426A2.425 2.425 0 0 0 0 35.497v10.685a2.425 2.425 0 0 0 2.425 2.425h7.516a31 31 0 0 0 3.455 8.013l-5.413 5.413a2.425 2.425 0 0 0 0 3.43l7.556 7.556a2.425 2.425 0 0 0 3.43 0l5.57-5.57a31 31 0 0 0 7.639 3.108v6.963a2.425 2.425 0 0 0 2.425 2.426h10.685a2.425 2.425 0 0 0 2.426-2.426v-6.948a31 31 0 0 0 8.004-3.3l5.8 5.8a2.425 2.425 0 0 0 3.43 0l7.556-7.555a2.425 2.425 0 0 0 0-3.43l-5.767-5.768a31 31 0 0 0 3.274-7.712h7.564A2.425 2.425 0 0 0 80 46.182V35.497a2.426 2.426 0 0 0-2.425-2.426m-58.819-.112a2.491 2.491 0 0 1 4.057-2.882c3.483-5.97 9.964-9.842 17.109-9.842 8.629 0 16.2 5.515 18.84 13.723a2.49 2.49 0 1 1-4.743 1.526 14.76 14.76 0 0 0-14.097-10.267c-5.024 0-9.608 2.559-12.305 6.574a2.49 2.49 0 0 1 .656 4.904l-4.412 1.114c-.971.25-2.139-.14-2.713-1.08zm41.718 17.466a2.49 2.49 0 0 1-3.287-.557c-3.484 5.97-9.964 9.843-17.109 9.843-8.629 0-16.2-5.515-18.84-13.724a2.491 2.491 0 0 1 4.742-1.525 14.76 14.76 0 0 0 14.098 10.266c5.024 0 9.607-2.558 12.304-6.572l-.047.002a2.492 2.492 0 0 1-.609-4.907l4.413-1.115c.967-.243 2.172.142 2.737 1.118l2.368 3.733a2.49 2.49 0 0 1-.77 3.438"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "settings_svg__a",
    x1: 40,
    x2: 40,
    y1: 0,
    y2: 79.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7CC6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD912F"
  })))));
};
export default SvgSettings;